import styled from "@emotion/styled";
import colors from "../../styles/colors";
import { css } from "@emotion/react";
import { Tooltip } from "react-tooltip";
/**
 * Styled Input field label.
 */
export const InputFieldLabelStyled = styled.label `
  font-family: Inter;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: ${colors["color-gray-140"]};

  ${(props) => getCurrentStateInputFieldLabel(props.showError, props.showWarning)}
`;
export const InputFieldLabelContainerStyled = styled.div `
  display: flex;
  align-items: center;
  gap: 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const ToolTipContainerStyled = styled.div `
  display: flex;
  cursor: pointer;
`;
/**
 * Styled tooltip.
 */
export const ToolTipStyled = styled(Tooltip) `
  font-family: Inter;

  &.tooltip-class {
    font-size: 0.75rem;
    background-color: ${colors["color-gray-160"]};
    font-weight: 400;
    line-height: 1.125rem;
    padding: 0.75rem;
    text-align: left;
    opacity: 1;
    p {
      margin: 0rem;
    }
  }
`;
/**
 * Function to return css for error state for input field label component
 * @param {boolean} showError
 * @returns {string} updated css
 */
export function getCurrentStateInputFieldLabel(showError, showWarning) {
    return showError || showWarning
        ? css `
        color: ${colors[showError ? "color-red-160" : "color-gold-160"]};
      `
        : null;
}
//# sourceMappingURL=InputFieldLabel.styled.js.map